import { set, upd } from "../../common/util/Immutable";
import { TAnyNodeID } from "../_generated/NodeTypes";
import { useSharedState } from "../app/useSharedState";
import Control from "../Control";
import { useOnDrag } from "../hooks/useOnDrag";

export function GridControl({ id }: { id: TAnyNodeID }) {
  const [scene, setScene] = useSharedState("scene");

  const [px, py] = scene.positions[id];
  // const { id: parentId, key, subKey } = scene.nodes[id].parent;

  // const [onDragBegin] = useOnDrag(
  //   { type: "move_wiring_control", controlId: id },
  //   (e, [ox, oy], [dx, dy]) => {
  //     setScene(
  //       upd(scene, "nodes", (v) =>
  //         upd(v, parentId, (v) =>
  //           upd(v, "children", (v) =>
  //             upd(v, key, (v) =>
  //               subKey === undefined
  //                 ? set(v, id, [px + dx, py + dy])
  //                 : upd(v, subKey, (v) =>
  //                     set(v, "position", [px + dx, py + dy])
  //                   )
  //             )
  //           )
  //         )
  //       )
  //     );
  //   }
  // );
  const [onDragBegin] = useOnDrag(
    { type: "move_wiring_control", controlId: id },
    (e, [ox, oy], [dx, dy]) => {
      setScene(upd(scene, "positions", (v) => set(v, id, [px + dx, py + dy])));
    }
  );

  return (
    <div
      key={id}
      style={{
        position: "absolute",
        left: px,
        top: py,
      }}
    >
      <Control id={id} onDragBegin={onDragBegin} />
    </div>
  );
}
